module.exports = __webpack_public_path__ + "static/media/one_leg.f5d3c653.svg";